import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownHeader',
    baseStyle: {
      border: `1px solid ${theme.colors.border15}`,
      borderRadius: theme.sizes['-4'],
      color: theme.colors.muted,
      gap: theme.space['xs'],

      ['&::placeholder']: {
        color: theme.colors.muted
      }
    }
  };
}
